import { render, staticRenderFns } from "./StudentOrderPayment.vue?vue&type=template&id=70cabc69&scoped=true&"
import script from "./StudentOrderPayment.vue?vue&type=script&lang=js&"
export * from "./StudentOrderPayment.vue?vue&type=script&lang=js&"
import style0 from "./StudentOrderPayment.vue?vue&type=style&index=0&id=70cabc69&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cabc69",
  null
  
)

export default component.exports